import React, { useState } from "react";
import { useContext } from "react";
import { container, Container } from "./NavBar"
import {FcCheckmark} from "react-icons/fc"
import "../Styles/Pricing.css";


function Pricing(){
  const {toggle} = useContext(container)
  const [toggleBasic,setToggleBasic] = useState(true)
  const [toggleStandard,settoggleStandard] = useState(true)
  const [togglePremium,setTogglePremium] = useState(true)

  const [basicCost,setBasicCost] = useState("6.99")
  const [standardCost,setStandardCost] = useState("11.99")
  const [premiumCost,setPremiumCost] = useState("17.99")
  return(
    <>
  <div className={toggle ? "backgroun-Color-Main" : "backgroun-Color-secondary"}>
    <div className="pricing-container">
      <div className={toggle ? "Pricing-option1" : "light-Theme1"}>
        <h2>Basic</h2>
        <div className="price">
          <h3>{basicCost}$</h3><h4 id="MonthlyYearly" className="h4">{toggleBasic ? "/Monthly" : "/Yearly"}</h4>
        </div>
           <span><FcCheckmark fontsize={25} id="checkmark"/>Ulimited films and tv programes</span>
           <span><FcCheckmark fontsize={25} id="checkmark"/>Watch on mobile phones and tablets</span>
           <span><FcCheckmark fontsize={25} id="checkmark"/>Cancel at anytime</span>
           <span><FcCheckmark fontsize={25} id="checkmark"/>First month completely free</span>
           <button id="button1">Buy Now</button>
           <div id="darktheme">
            <div className="Pricing-yearly-darktheme" onClick={() => {
              setToggleBasic(!toggleBasic)
              if(toggleBasic){
                setBasicCost("60")
              }else{
                setBasicCost("7.99")
              }
             }}>
              <div className={toggleBasic ? "Pricing-monthly-darktheme" : "Pricing-monthly-light"}></div>
            </div> 
           </div>
      </div>
    </div>
    <div className={toggle ? "Pricing-option2" : "light-Theme2"}>
      <h2>standard</h2>
      <div className="Price">
            <h3>{standardCost}$</h3><h4 id="MonthlyYearly">{toggleStandard ? "/Monthly" : "/Yearly"}</h4>
      </div>
      <span><FcCheckmark fontSize={25} id="checkmark"/>Unlimited films and tv programes</span>
      <span><FcCheckmark fontSize={25} id="checkmark"/>Watch on mobile phones and tablets</span>
      <span><FcCheckmark fontSize={25} id="checkmark"/>Cancel at anytime</span>
      <span><FcCheckmark fontSize={25} id="checkmark"/>First month completely free</span>
      <span><FcCheckmark fontSize={25} id="checkmark"/>HD available</span>
      <button id="button2">Buy Now</button>
      <div id="darktheme">
        <div className="Pricing-yearly-darktheme tog2" onClick={() => {
          settoggleStandard(!toggleStandard)
          if(toggleStandard){
            setStandardCost("120")
          }
          else{
            setStandardCost("11.99")
          }
        }}>
          <div className={toggleStandard ? "Pricing-monthly-darktheme" : "Pricing-monthly-light"}></div>

        </div>
      </div>
    </div>
    <div>
      <div className={toggle ? "Pricing-option3" : "light-Theme3"}>
        <h2>Premium</h2>
        <div className="Price">
          <h3>{premiumCost}$</h3><h4 id="MonthlyYearly">{togglePremium ? "/Monthly" : "/Yearly"}</h4>
        </div>
        <span><FcCheckmark fontSize={25} id="checkmark"/>Unlimited films and tv programes</span>
      <span><FcCheckmark fontSize={25} id="checkmark"/>Watch on mobile phones and tablets</span>
      <span><FcCheckmark fontSize={25} id="checkmark"/>Cancel at anytime</span>
      <span><FcCheckmark fontSize={25} id="checkmark"/>First month completely free</span>
      <span><FcCheckmark fontSize={25} id="checkmark"/>HD available</span>
      <button id="button3">Buy Now</button>
      <div id="darktheme">
        <div className="Pricing-yearly-darktheme tog3" onClick={() => {
          setTogglePremium(!togglePremium)
          if(togglePremium){
            setPremiumCost("120")
          }
          else{
            setPremiumCost("11.99")
          }
        }}>
          <div className={togglePremium ? "Pricing-monthly-darktheme" : "Pricing-monthly-light"}></div>
        
      </div>
    </div>
  </div>
  </div>
  </div>

  
  </>
)
}

export default Pricing;
